import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userInfo: null,
};

export const authSlice = createSlice({
    initialState,
    name: 'authSlice',
    reducers: {
        loadUserFromStorage: (state) => {
            const userData = localStorage.getItem('cfUser');
            if (userData) {
                state.userInfo = JSON.parse(userData);
            }
        },
        setUser: (state, { payload }) => {
            state.userInfo = payload;
        },
        logout: (state) => {
            Object.assign(state, initialState)
            localStorage.removeItem('cfUser')
        },
    },
});

export default authSlice.reducer;

export const { logout, setUser, setUserDasboard, loadUserFromStorage } = authSlice.actions;